module.exports = __webpack_public_path__ + "media/images/calendar/january-e361caea538961a681889517108faddc.jpg";